import { type ReactNode } from 'react';
import { Stack, Typography, Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import { SideIllustration, Logo } from '@app/components';
import { Strings } from '@app/constants';
import { StyledContent, StyledCopyright } from './styles';

// --------------------------------------------------------------

interface Props {
  children: ReactNode;
  title: string;
}

// const hideIllustrationBreakpoints: Breakpoint[] = ['xs', 'sm'];
// const showLogoBreakpoints: Breakpoint[] = ['lg', 'md', 'xl'];

const AuthLayout = ({ children }: Props) => {
  // const hideIllustration =
  //   useMediaQuery((theme: any) => theme.breakpoints.only('xs')) ||
  //   useMediaQuery((theme: any) => theme.breakpoints.only('sm'));

  // const hideLogo =
  //   useMediaQuery((theme: any) => theme.breakpoints.only('lg')) ||
  //   useMediaQuery((theme: any) => theme.breakpoints.only('md')) ||
  //   useMediaQuery((theme: any) => theme.breakpoints.only('xl'));

  const isXs = useMediaQuery((theme: any) => theme.breakpoints.only('xs'));
  const isSm = useMediaQuery((theme: any) => theme.breakpoints.only('sm'));
  const isLg = useMediaQuery((theme: any) => theme.breakpoints.only('lg'));
  const isMd = useMediaQuery((theme: any) => theme.breakpoints.only('md'));
  const isXl = useMediaQuery((theme: any) => theme.breakpoints.only('xl'));

  const hideIllustration = isXs || isSm;
  const hideLogo = isLg || isMd || isXl;

  return (
    <>
      <Stack direction="row" flex={1}>
        {!hideIllustration && (
          <Box width="40%" height={1}>
            <SideIllustration />
          </Box>
        )}

        <StyledContent>
          {!hideLogo && (
            <Stack alignItems="center" mb={5}>
              <Logo disabledLink />
            </Stack>
          )}

          {children}

          <StyledCopyright>
            {!hideIllustration && <Box width="40%" />}

            <Typography variant="body2" flex={1} textAlign="center">
              {Strings.common.copyright}
            </Typography>
          </StyledCopyright>
        </StyledContent>
      </Stack>
    </>
  );
};

export { AuthLayout };
